// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

import { render, createElement, Component } from '../../utils';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { CLS_PREFIX, Z_INDEX_TOASTER } from '../../constants';
import Toast from '../Toast';
import Layer from '../Layer';

import './Toaster.less';

let toastId = 0;

/**
 * Toaster component.
 */
class Toaster extends Component {
    constructor(props) {
        super(props);
        this.state = {
            toasts: (this.props.toasts || []).map(toast => ({ key: `toast-${toastId++}`, ...toast })),
        };
    }

    /**
     * Add a new toast
     *
     * @param {Object} props Toast props { type, message }
     * @returns {string} New toast key
     * @public
     */
    add(props) {
        const key = `toast-${toastId++}`;
        this.setState(({ toasts }) => ({
            toasts: [{ ...props, key }, ...toasts],
        }));
        return key;
    }

    /**
     * Update toast by key
     *
     * @param {string} key
     * @param {Object} props New props
     * @returns {string} Updated toast key
     * @public
     */
    update(key, props) {
        this.setState(({ toasts }) => ({
            toasts: toasts.map(toast => toast.key === key ? { ...props, key } : toast),
        }));
        return key;
    }

    /**
     * Remove toast by key
     *
     * @param {string} key
     * @public
     */
    remove(key) {
        this.setState(({ toasts }) => ({
            toasts: toasts.filter(toast => toast.key !== key),
        }));
    }

    /**
     * Clear all toasts
     *
     * @public
     */
    clear() {
        this.setState({
            toasts: [],
        });
    }

    render() {
        const {
            baseClassName,
            className,
            toasts,
            position,
            ...props
        } = this.props;

        return (
            <Layer level={Z_INDEX_TOASTER}>
                <div
                    className={classNames(
                        baseClassName,
                        {
                            [`${baseClassName}--${position}`]: position,
                        },
                        className,
                    )}
                    {...props}
                >
                    <TransitionGroup component="span">
                        {this.state.toasts.map(toastProps => (
                            <CSSTransition
                                key={toastProps.key}
                                classNames={`${Toast.defaultProps.baseClassName}-`}
                                timeout={{
                                    enter: 300,
                                    exit: 300,
                                }}
                            >
                                <Toast {...toastProps} onClose={() => this.remove(toastProps.key)} />
                            </CSSTransition>
                        ))}
                    </TransitionGroup>
                </div>
            </Layer>
        );
    }
}

Toaster.create = (props = {}, container = document.body) => {
    const containerElement = document.createElement('div');
    container.appendChild(containerElement);

    return render(<Toaster {...props} />, containerElement);
};

Toaster.propTypes = {
    /**
     * Toaster position
     */
    position: PropTypes.oneOf(['top']),
    toasts: PropTypes.array,
    /**
     * @ignore
     */
    className: PropTypes.string,
    /**
     * @ignore
     */
    baseClassName: PropTypes.string,
};

Toaster.defaultProps = {
    position: 'top',
    toasts: null,
    className: null,
    baseClassName: `${CLS_PREFIX}toaster`,
};

export default Toaster;



// WEBPACK FOOTER //
// ./components/Toaster/Toaster.js